export const DEFAULT_FETCH_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export const API_END_POINTS = {
  genNewsArticles: {
    pttUrl: '/api/v1/writing/assistant/ptt/news',
    content: '/api/v1/writing/assistant/material/news',
  },
  genNewsTitles: '/api/v1/writing/assistant/news/titles',
  genNewsHashtags: '/api/v1/writing/assistant/news/hashtags',
  correctTypos: '/api/v1/writing/assistant/news/typos',
  givePlatformFeedback: '/api/v1/feedback/platform',
};
